<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title" style="position: relative;">
            用户资料
        </div>
        <div class="user_content_blcok_line"></div>
  
        <div class="admin_form_main">
            <el-form  label-width="60px" ref="info" :model="info">
              <el-row :span="24">
                  <el-col :span="12">
                      <el-form-item label="账号" prop="username" >
                          <el-input type="text" v-model="info.username" :disabled="true"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="手机" prop="mobile" >
                          <el-input type="text" v-model="info.mobile" :disabled="true"> ~ 已验证，不可修改</el-input>
                      </el-form-item>
                  </el-col>
              </el-row>
              <!-- <el-row>
                <el-col :span="12">
                    <el-form-item label="邮箱" prop="email" :rules="[{type:'email',message:'邮箱格式非法',trigger: 'blur' }]">
                        <el-input type="email" placeholder="邮箱" v-model="info.email"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="性别" prop="gender" class="red_radio">
                        <el-radio-group v-model="info.gender">
                            <el-radio :label="0">男</el-radio>
                            <el-radio :label="1">女</el-radio>
                            <el-radio :label="2">未知</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
              </el-row> -->
              <el-row :span="24">
                  <el-col :span="12">
                    <el-form-item label="称呼" prop="realName" :rules="[{required:true,message:'姓名不能为空',trigger: 'blur' }]">
                        <el-input placeholder="请输入内容" v-model="info.realName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="职务" prop="post" :rules="[{required:true,message:'职务不能为空',trigger: 'change' }]">
                          <el-select v-model="info.post" style="width:100%;color:#000">
                              <el-option value="销售经理" label="销售经理"></el-option>
                              <el-option value="采购经理" label="采购经理"></el-option>
                              <el-option value="项目经理" label="项目经理"></el-option>
                              <el-option value="工程技术人员" label="工程技术人员"></el-option>
                              <el-option value="其他" label="其他"></el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row :span="24">
                  <el-col :span="12">
                      <el-form-item label="公司" prop="company" :rules="[{required:true,message:'公司不能为空',trigger: 'blur' }]">
                          <el-input type="text" v-model="info.company"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="行业" prop="industry" :rules="[{required:true,message:'行业不能为空',trigger: 'blur' }]">
                          <el-input type="text" v-model="info.industry"></el-input>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row :span="24">
                <el-col :span="12">
                      <el-form-item label="地址" prop="areaCode" :rules="[{required:true,message:'地址不能为空',trigger: 'blur' }]">
                          <el-cascader v-model="info.areaCode"  :options="area_list"></el-cascader>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="头像" prop="avatar" class="avatar" :rules="[{required:true,message:'头像尚未上传',trigger: 'blur' }]">
                        <el-upload
                            :action="'https://api.createszjc.com/sys/file/upload?access_token=' + token" accept=".jpg,.jpeg,.png,.bmp,.gif" :before-upload="beforeUpload" :on-success="handleSuccess"
                            :file-list="info.fileList"
                            list-type="picture-card"
                            :on-remove="handleRemove"
                            ref="uploadRef"
                            :limit="1"
                            :class="{ disUpload:info.fileList.length>0 }"
                            style="width:45%;">
                            <i v-if="info.fileList.length < 1" class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                  </el-col>
              </el-row>
              <div style="text-align: center;">
                    <el-button type="danger" style="width: 100px;margin-top: 20px;" @click="submitForm('info')">提交</el-button>
                    <!-- <el-button @click="resetForm('info')">重置</el-button> -->
              </div>
            </el-form>
        </div>
    </div>
  </template>
  
  <script>
  import { _local } from "@/plugins/local-storage.js"
  import {regionData,CodeToText,TextToCode} from 'element-china-area-data'
  
  export default {
    components: {},
    props: {},
    data() {
      return {
          info:{
              realname:'',
              avatar:'',
              email:'',
              mobile:'',
              gender:0,
              post: null,
              company: '',
              industry: '',
              areaCode:[],
              fileList:[]
          },
          upload_headers:{},
          area_list:regionData,
          token: _local.get('token')
      };
    },
    watch: {},
    computed: {},
    methods: {
        submitForm:function(e){
            let _this = this;
            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    _this.edit_user_info();
                }
            });
        },
        get_user_info:function(){
            this.$get(this.$api.userInfo).then(res=>{
                this.info = res.data;

                if(res.data.wxAvatar){
                    this.info.fileList = [{url:res.data.wxAvatar}]
                    this.info.avatar = res.data.wxAvatar
                }else{
                    this.info.fileList = []
                    this.info.avatar = ''
                }
                
                const regionArr = res.data.region.split('/')
                const detail = {
                    province:regionArr[0],
                    city:regionArr[1],
                    county:regionArr[2]
                }
                this.info.areaCode = this.createRegion(detail)
            });
        },
        edit_user_info:function(){
            const params={
                ...(this.info),
				wxAvatar: this.info.avatar,
				realName: this.info.realName,
				company: this.info.company,
				post: this.info.post,
				industry: this.info.industry,
                region: CodeToText[(this.info.areaCode[0])] + '/' + CodeToText[(this.info
								.areaCode[1])] + '/' + CodeToText[(this.info.areaCode[2])],
            }

            delete params.fileList
            delete params.areaCode
            this.$put(this.$api.homeAuthProfile,params).then(res=>{
                if (res.code === 0) {
                    this.$message.success('修改成功');
                    this.get_user_info();
                }else
                    return this.$message.error(res.msg);
            });
        },
        // 转换区域编码
        createRegion(detail) {
            const province = TextToCode[detail.province].code
            const city = TextToCode[detail.province][detail.city].code
            const county = TextToCode[detail.province][detail.city][detail.county].code

            return [province, city, county]
        },
        handleRemove() {
            this.info.avatar = ''
            this.info.fileList = [];
            this.$forceUpdate()
        },
        handleEditChange(file, fileList) {
            this.info.fileList = fileList;
        },

        //  图片上传成功的方法
        handleSuccess(res){
            if (res.code != 0) {
                this.$message.error('上传失败：' + res.msg)
                return false
            }
            
            this.info.avatar = res.data.url
            this.info.fileList=[{url:res.data.url}]
            this.$forceUpdate()
        },
        
        //  图片上传成功之前
        beforeUpload(file){
            const fileName = file.name
            const fileType = fileName.substring(fileName.lastIndexOf('.'))
            if (file.size / 1024 / 1024 > 2) {
                this.$message.error('文件大小不能超过2M')
                return false
            }else{
                if(fileType ==='.jpg'||fileType === '.jpeg' || fileType === '.png' || fileType === '.bmp' || fileType === '.gif'){
                    return true
                }else{
                    this.$message.error('请上传格式正确的图片！')
                    return false
                }
            }
        }
    },
    created() {
        // this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
        this.get_user_info();
    },
    mounted() {}
  };
  </script>
  <style lang="scss" scoped>
  .el-row{
      margin-bottom: 0;
  }
  .el-cascader{
    width: 100%;
  }


  /deep/ .el-upload-list__item{
    transition: none;
    margin: 0
  }
  .avatar /deep/ .el-form-item__content{
    height: 85px;
  }
  .disUpload /deep/ .el-upload{
    display: none;
  }
  .disUpload{
    height: 80px;
  }
  /deep/ .el-upload-list__item{
    width: 80px !important;
    height: 80px !important;
  }
  /deep/ .el-upload--picture-card{
    width: 80px !important;
    height: 80px !important;
    line-height: 80px !important;
    i{
        vertical-align: middle;
    }
  }
  /deep/.el-upload-list__item-status-label{
    display: none !important;
  }
  </style>